const Redirect = ({route}) => {
    // eslint-disable-next-line
    location.href = 'https://homepage.alexhinterleitner.com/' + route;
}

export default Redirect